import {NgModule} from '@angular/core';
import{Routes,RouterModule} from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';


const routes:Routes=[
    //dashboard
    {path: 'analytics/dashboard',component:DashboardComponent},
]
@NgModule({

    imports:[RouterModule.forChild(routes)] ,
    exports:[RouterModule]
})

export class analyticsRoutingModule {

}  